"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nasino": {
    "d5380a8c": [{
      "hkey": "6ec14ee6",
      "slug": "nasino",
      "name": "Nasino",
      "primary": true,
      "skipSearch": false
    }],
    "beo": [{
      "hkey": "6ec14ee6",
      "slug": "nasino",
      "name": "Nasino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cceced6b": [{
      "hkey": "6ec14ee6",
      "slug": "nasino",
      "name": "Nasino",
      "primary": true,
      "skipSearch": false
    }],
    "casale": [{
      "hkey": "6ec14ee6",
      "slug": "nasino",
      "name": "Nasino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ed22f056": [{
      "hkey": "a0de7115",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa": [{
      "hkey": "a0de7115",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "230422a0": [{
      "hkey": "a0de7115",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "costa": [{
      "hkey": "a0de7115",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nasino"
    }],
    "bd53e5c0": [{
      "hkey": "6ec14ee6",
      "slug": "nasino",
      "name": "Nasino",
      "primary": true,
      "skipSearch": false
    }],
    "mulino": [{
      "hkey": "6ec14ee6",
      "slug": "nasino",
      "name": "Nasino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "18b26132": [{
      "hkey": "6ec14ee6",
      "slug": "nasino",
      "name": "Nasino",
      "primary": true,
      "skipSearch": false
    }],
    "perati": [{
      "hkey": "6ec14ee6",
      "slug": "nasino",
      "name": "Nasino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8e4b6634": [{
      "hkey": "6ec14ee6",
      "slug": "nasino",
      "name": "Nasino",
      "primary": true,
      "skipSearch": false
    }],
    "vignoletto": [{
      "hkey": "6ec14ee6",
      "slug": "nasino",
      "name": "Nasino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;